import { Outlet } from 'react-router-dom';

import { UnsavedGuardProvider } from '../nav/unsaved-guard';
import { SideNav } from './SideNav';
import { TopBar } from './TopBar';

/**
 * Shell chrome: WP-admin-familiar frame — full-width dark top bar, dark left
 * side nav, light content region (faithful-UI-port; chrome tokens in
 * ../styles/app.css). Play never shipped chrome (wp-admin provided it), so
 * this is net-new design over the ported palette.
 *
 * The whole frame sits under `UnsavedGuardProvider` (ADR-030): routed pages
 * register dirty state via `useUnsavedChangesGuard`, and SideNav consults
 * `useConfirmNavigate()` before letting a rail click discard it.
 */
export function AppLayout() {
  return (
    <UnsavedGuardProvider>
      <div className="min-h-screen flex flex-col bg-bg-subtle">
        <TopBar />
        <div className="flex flex-1">
          <SideNav />
          {/* WHITE content region (L8 round 11 item 10 — operator preference, a
              deliberate divergence from Play's #f0f0f1 wp-admin content area).
              `--color-bg-subtle` is deliberately NOT changed: it is byte-parity
              with Play's palette and shared by the root div, `body` and every
              other `bg-bg-subtle` consumer. Cards are `bg-bg` too, so their
              `border-border` is now the only thing separating them from the page. */}
          <main className="flex-1 min-w-0 p-5 bg-bg">
            <Outlet />
          </main>
        </div>
      </div>
    </UnsavedGuardProvider>
  );
}
